import CacheAPI from '../api.cache.js'
import { Observable } from 'rxjs'
import { store } from '../../store/store.js'
import { storeVDog } from '../../store/storeVDog.js'
import axios from 'axios'
import Vue from 'vue'
require('es6-promise').polyfill()

const cacheAPI = CacheAPI(false, 6000, {
  '/Ticket/InsertTicket': true,
  '/Ticket/DeleteTicket': true,
  '/Ticket/GetOpenTickets': true,
  '/TimeServer/GetServerTime': true,
  '/Round/GetRound': true,
  '/Ticket/GetTicketHistory': true
})

const UtilsMethod = {
  create2DArray (rows) {
    var arr = []
    for (var i = 0; i < rows; i++) {
      arr[i] = []
    }
    return arr
  }
}
const api = (function () {
  let VGameName = 'VDogs'
  axios.interceptors.request.use(function (config) {
    if (store) {
      let url = store.getUrlByGameName(VGameName)
      if (config.url.indexOf(url) >= 0) {
        let token = store.getTokenByGameName(VGameName)
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })
  return {
    buildUrl (url) {
      let urlData = store.getUrlByGameName(VGameName) + url
      return urlData
    },
    getPostRequest (url, params) {
      return Observable.create((observer) => {
        if (cacheAPI.isUrlExcluded(url) || cacheAPI.isExpired(url)) {
          axios.post(this.buildUrl(url), params).then(response => {
            if (!cacheAPI.isUrlExcluded(url)) {
              cacheAPI.setCache(url, params, response.data)
            }
            observer.next(response.data)
            observer.complete()
          }, response => {
            observer.error(response)
            observer.complete()
          })
        } else {
          let response = cacheAPI.getCache(url)
          observer.next(response.data)
          observer.complete()
        }
      })
    },
    getRound (roundNo) {
      return Observable.create((observer) => {
        let params = null
        if (roundNo > 0) {
          params = { 'RoundNo': roundNo }
        }
        this.getPostRequest('/Round/GetRound', params).subscribe(response => {
          let winingTable = UtilsMethod.create2DArray(6)
          let combinationTable = UtilsMethod.create2DArray(6)
          let combinationRawDataTable = []
          let doubleChangeTable = UtilsMethod.create2DArray(6)
          let doubleChangeRawDataTable = []
          let trifectaTable = []
          let sum12Table = []
          let sum123Table = []
          let lowHighTable = []
          let oddEvenTable = []

          if (response && response.Stakes && response.Stakes.length > 0) {
            // Wining table
            let winingTableTableColumn1 = []
            let winingTableTableColumn2 = []
            let winingTableTableColumn3 = []
            let winingTableTableColumn4 = []
            let winingTableTableColumn5 = []
            let winingTableTableColumn6 = []
            response.Stakes.forEach(element => {
              element.roundNo = response.RoundNo
              switch (element.StakeTypeEnum) {
                case 1:
                  element.tableName = 'vdog_winner'
                  winingTableTableColumn1.push(element)
                  break
                case 2:
                  element.tableName = 'vdog_in_first_2'
                  winingTableTableColumn2.push(element)
                  break
                case 3:
                  element.tableName = 'vdog_in_first_3'
                  winingTableTableColumn3.push(element)
                  break
                case 4:
                  element.tableName = 'vdog_not_a_winner'
                  winingTableTableColumn4.push(element)
                  break
                case 5:
                  element.tableName = 'vdog_not_in_first_2'
                  winingTableTableColumn5.push(element)
                  break
                case 6:
                  element.tableName = 'vdog_not_in_first_3'
                  winingTableTableColumn6.push(element)
                  break
                case 7:
                  element.tableName = 'vdog_low_high'
                  lowHighTable.push(element)
                  break
                case 8:
                  element.tableName = 'vdog_odd_even'
                  oddEvenTable.push(element)
                  break
                case 9:
                  element.tableName = 'vdog_sum_1_2'
                  sum12Table.push(element)
                  break
                case 10:
                  element.tableName = 'vdog_sum_1_2_3'
                  sum123Table.push(element)
                  break
                case 11:
                  element.tableName = 'vdog_combination_betting'
                  combinationRawDataTable.push(element)
                  break
                case 12:
                  element.tableName = 'vdog_trifecta'
                  trifectaTable.push(element)
                  break
                case 13:
                  element.tableName = 'vdog_double_chance'
                  doubleChangeRawDataTable.push(element)
                  break
              }
            })
            // lowHighTable
            lowHighTable.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            // oddEvenTable
            oddEvenTable.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            // sum12Table
            sum12Table.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            // sum123Table
            sum123Table.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)

            // winingTable
            winingTableTableColumn1.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            winingTableTableColumn2.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            winingTableTableColumn3.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            winingTableTableColumn4.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            winingTableTableColumn5.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)
            winingTableTableColumn6.sort((e1, e2) => e1.StakeEnum - e2.StakeEnum)

            for (let i = 0; i < 6; i++) {
              winingTable[i].push(winingTableTableColumn1[i])
              winingTable[i].push(winingTableTableColumn2[i])
              winingTable[i].push(winingTableTableColumn3[i])
              winingTable[i].push(winingTableTableColumn4[i])
              winingTable[i].push(winingTableTableColumn5[i])
              winingTable[i].push(winingTableTableColumn6[i])
            }
            // combination betting
            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < 6; j++) {
                combinationTable[i][j] = { 'ID': '', 'Factor': 0 }
              }
            }
            combinationRawDataTable.forEach(element => {
              let first = Math.floor(element.StakeEnum / 10)
              let second = element.StakeEnum % 10
              combinationTable[first - 1][second - 1] = element
            })
            // double chance
            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < 6; j++) {
                doubleChangeTable[i][j] = { 'ID': '', 'Factor': 0 }
              }
            }
            doubleChangeRawDataTable.forEach(element => {
              let first = Math.floor(element.StakeEnum / 10)
              let second = element.StakeEnum % 10
              doubleChangeTable[first - 1][second - 1] = element
            })
          }

          let responseData = {
            'ResponseCode': response.ResponseCode,
            'Message': response.Message,
            'RoundNo': response.RoundNo,
            'PreviousRoundNo': response.PreviousRoundNo,
            'Data': { }
          }
          responseData.Data = {
            'winingTable': winingTable,
            'combinationTable': combinationTable,
            'doubleChangeTable': doubleChangeTable,
            'trifectaTable': trifectaTable,
            'sum12Table': [sum12Table],
            'sum123Table': [sum123Table],
            'lowHighTable': [lowHighTable],
            'oddEvenTable': [oddEvenTable]
          }
          observer.next(responseData)
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getVideolist () {
      return this.getPostRequest('/Videolist/GetVideolist')
    },
    getConfig () {
      return Observable.create((observer) => {
        this.getPostRequest('/Config/GetConfig').subscribe(response => {
          observer.next(response)
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getOpenTickets () {
      return this.getPostRequest('/Ticket/GetOpenTickets', {
        'currentOperator': store.getUsername(),
        'gameInProgress': storeVDog.isGameInProgress()
      })
    },
    getResults () {
      return Observable.create((observer) => {
        return this.getPostRequest('/Result/GetResults').subscribe(response => {
          let result = []
          if (response && response.Results) {
            result = response.Results.slice(0, 4)
          }
          observer.next(result)
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getServerTime () {
      return this.getPostRequest('/TimeServer/GetServerTime')
    },
    getRoundResult (roundNo) {
      return this.getPostRequest('/Result/GetRoundResults', { RoundNo: roundNo })
    },
    getVideoLink (roundNo, roundLength, secondsToStart) {
      return Observable.create((observer) => {
        return this.getPostRequest('/Result/GetRoundResults', { RoundNo: roundNo })
          .subscribe(response => {
            let passSec = roundLength - secondsToStart
            let videoPositionPercentage = ((passSec * 1000) / response.TotalLength) * 100
            if (videoPositionPercentage < 70) {
              storeVDog.setGameInProgress(true)
              observer.next({
                'videoList': [response.VideoUrl],
                'videoSeek': passSec,
                'videoListTemp': [response.VideoUrl]
              })
            } else {
              storeVDog.setGameInProgress(false)
              observer.next({
                'videoList': [],
                'videoSeek': 0,
                'videoListTemp': [response.VideoUrl]
              })
            }
            observer.complete()
          }, error => {
            observer.error(error)
            observer.complete()
          })
      })
    },
    getJackpot () {
      return Observable.create((observer) => {
        this.getPostRequest('/Jackpot/GetJackpot').subscribe(response => {
          let localJackpot = []
          let superJackpot = []
          let winningJackpotsSuper = []
          let winningJackpotsLocal = []
          if (response.Jackpots && response.Jackpots.length > 0) {
            Object.keys(response.Jackpots).forEach((key) => {
              for (const [prop, value] of Object.entries(response.Jackpots[key])) {
                if (prop === 'Type' && value.includes('Super JP')) {
                  superJackpot = [...superJackpot, response.Jackpots[key]]
                } else if (prop === 'Type' && value.includes('Local JP')) {
                  localJackpot = [...localJackpot, response.Jackpots[key]]
                }
              }
            })
          }
          if (response.LocalPastWinningTickets && response.LocalPastWinningTickets.length > 0) {
            winningJackpotsLocal = response.LocalPastWinningTickets
          }
          while (winningJackpotsLocal.length < 3) {
            winningJackpotsLocal.push({ Barcode: '-' })
          }
          if (response.SuperPastWinningTickets && response.SuperPastWinningTickets.length > 0) {
            winningJackpotsSuper = response.SuperPastWinningTickets
          }
          while (winningJackpotsSuper.length < 3) {
            winningJackpotsSuper.push({ Barcode: '-' })
          }
          observer.next({
            'jackpots': response.Jackpots,
            'localJackpot': localJackpot,
            'superJackpot': superJackpot,
            'winningJackpotsSuper': winningJackpotsSuper,
            'winningJackpotsLocal': winningJackpotsLocal
          })
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getWinningJackpot () {
      return this.getPostRequest('/Jackpot/GetWinningJackpot')
    },
    deleteTicket (ticketID) {
      return this.getPostRequest('/Ticket/DeleteTicket', { ticketCheckID: ticketID })
    },
    checkTicketAsync (ticketID) {
      return this.getPostRequest('/Ticket/CheckTicket', {
        ticketCheckID: ticketID,
        currentOperator: store.getUsername()
      })
    },
    getBalance () {
      this.getPostRequest('/Balance/GetBalance').subscribe(data => {
        store.setBalance(data.BalanceInCents / 100)
        store.setCurrency(data.Currency)
      })
    },
    getBetHistoryTickets (dateFrom = null, dateTo = null) {
      return Observable.create((observer) => {
        dateFrom = dateFrom.setHours(0, 0, 0, 0)
        dateFrom = new Date(dateFrom)
        dateTo = dateTo.setHours(23, 59, 59, 999)
        dateTo = new Date(dateTo)
        return this.getPostRequest('/Ticket/GetTicketHistory', {
          'currentOperator': store.getUsername(),
          'gameInProgress': storeVDog.isGameInProgress(),
          'option': 2,
          'dateFrom': dateFrom,
          'dateTo': dateTo
        }).subscribe(response => {
          response.PlayedTickets.forEach(element => {
            Vue.set(element, 'winningTicket', false)
            Vue.set(element, 'Status', 0)
            for (let i = 0; i < element.TicketList.length; i++) {
              if (element.TicketList[i].Payout > 0) {
                Vue.set(element, 'winningTicket', true)
                Vue.set(element, 'Status', 1)
              }
              if (element.TicketList[i].Status === 2) {
                Vue.set(element, 'Status', 2)
              }
            }
            Vue.set(element, 'isOpen', false)
          })
          let tickets = response.PlayedTickets.filter(item => item.Status !== 2)
          observer.next(tickets)
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    insertTicket (ticketList) {
      return this.getPostRequest('/Ticket/InsertTicket', {
        'currentOperator': store.getUsername(),
        'TicketList': ticketList
      })
    }
  }
})()

export default api
